import React from 'react';
import { ChevronRight } from 'lucide-react';
import PageLayout from '../components/PageLayout';
import { techniquesPageData } from '../data/mockData';

const HealingTechniquesPage = () => {
  return (
    <PageLayout scriptLabel={techniquesPageData.scriptLabel} heading={techniquesPageData.heading}>
      {/* Intro */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <p className="font-open-sans text-[#666] text-lg leading-relaxed text-center mb-10">
            {techniquesPageData.intro}
          </p>

          {/* Conditions List */}
          <div className="bg-[#F3ECF8] rounded-sm p-8 md:p-10 mb-16">
            <h3 className="font-open-sans text-[#4A154B] text-sm tracking-[0.2em] font-bold uppercase mb-6">
              Helping you to cope with:
            </h3>
            <ul className="space-y-3">
              {techniquesPageData.conditions.map((condition, i) => (
                <li key={i} className="flex items-center gap-3">
                  <ChevronRight size={16} className="text-[#C9A84C] flex-shrink-0" />
                  <span className="font-open-sans text-[#555] text-base">{condition}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Techniques */}
      {techniquesPageData.techniques.map((technique, i) => (
        <section
          key={i}
          className={`py-14 px-4 ${i % 2 === 0 ? 'bg-white' : 'bg-[#F3ECF8]'}`}
        >
          <div className="max-w-4xl mx-auto">
            <div className={`grid md:grid-cols-[1fr_2fr] gap-8 items-start ${i % 2 !== 0 ? 'md:grid-cols-[2fr_1fr]' : ''}`}>
              {i % 2 !== 0 && (
                <div>
                  <p className="font-open-sans text-[#888] text-[15px] leading-relaxed">
                    {technique.description}
                  </p>
                </div>
              )}
              <div>
                <h3 className="font-open-sans text-[#1a1a1a] text-sm tracking-[0.2em] font-bold mb-4">
                  {technique.title}
                </h3>
                <div className="w-16 h-[2px] bg-[#C9A84C] mb-6" />
                {i % 2 !== 0 ? null : (
                  <p className="font-open-sans text-[#888] text-[15px] leading-relaxed">
                    {technique.description}
                  </p>
                )}
              </div>
              {i % 2 === 0 && (
                <div>
                  <p className="font-open-sans text-[#888] text-[15px] leading-relaxed">
                    {technique.description}
                  </p>
                </div>
              )}
            </div>
          </div>
        </section>
      ))}
    </PageLayout>
  );
};

export default HealingTechniquesPage;
